var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
import { ApolloClient, InMemoryCache, from } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { createUploadLink } from 'apollo-upload-client';
import React from 'react';
import { createNetworkStatusNotifier } from 'react-apollo-network-status';
import { addToast } from 'store/toastsSlice';
import i18n from '../i18n';
import store from '../store';
import initData from './initialData';
import { isLocallyHandledError } from './locallyHandledErrors';
import { handleReadOnlyError, isReadOnlyError, readOnlyLink } from './readOnlyAccess';
import typePolicies from './resolvers/typePolicies';
const cache = new InMemoryCache({
    typePolicies: typePolicies,
});
const deauthLink = onError((error) => {
    var _a;
    if (isReadOnlyError(error))
        return;
    if (!error.networkError ||
        !('statusCode' in error.networkError) ||
        ((_a = error.networkError) === null || _a === void 0 ? void 0 : _a.statusCode) !== 403)
        return;
    localStorage.removeItem('userId');
    localStorage.removeItem('token');
    sessionStorage.removeItem('token');
    window.location.replace('/login');
    const { response } = error;
    if (response)
        response.errors = undefined; // apollo będzie to dalej przetwarzał tak jakby to nie był błąd
});
const httpLink = createUploadLink({
    uri: process.env.GRAPHQL_URI || '',
});
export const AuthorizationHeaders = () => ({
    Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : '',
});
const authLink = setContext((_, { headers }) => ({
    headers: Object.assign(Object.assign({}, headers), AuthorizationHeaders()),
}));
const errorLink = onError((error) => {
    const { operation } = error;
    if (handleReadOnlyError(error, operation.getContext().silentReadOnly === true))
        return;
    if (!isLocallyHandledError(error)) {
        store.dispatch(addToast({
            color: 'negative',
            title: `${i18n.t('UNEXPECTED_ERROR')}`,
            description: (React.createElement(React.Fragment, null,
                i18n.t('unexpected_error'),
                ": ",
                React.createElement("code", null, operation.operationName),
                React.createElement("br", null),
                i18n.t('error_reload'))),
        }));
    }
});
const { link: statusLink, useApolloNetworkStatus } = createNetworkStatusNotifier();
const client = new ApolloClient({
    cache,
    link: from([statusLink, errorLink, deauthLink, readOnlyLink, authLink, httpLink]),
});
// for some initial value -> no resolver -> take form cache
initData(cache);
// for reset to intital value
client.onResetStore(() => __awaiter(void 0, void 0, void 0, function* () {
    initData(cache);
}));
export default client;
export { useApolloNetworkStatus };
export const ApiPath = '/api';
export const ApiUrl = ((_a = process.env.GRAPHQL_URI) === null || _a === void 0 ? void 0 : _a.replace(/\/graphql\/?$/, ApiPath)) || '';
export const ApiUrlContext = React.createContext(ApiUrl);
